import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
  selector: 'gtd-business-format',
  templateUrl: './business-format.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class BusinessFormatComponent {
  @Input() customClass = '';
  @Input() data: { format: string; value: number };

  getFormat(num: number): string {
    switch (num) {
      case 1:
        return 'money';
      default:
        return 'percentage';
    }
  }
}
